export const ACCESS_TOKEN = 'ACCESS_TOKEN'
export const USER_NAME = 'USER_NAME'
export const USER_IMAGE = 'USER_IMAGE'
export const USER_ID = 'USERID'
export const UER_ROLE = 'UERROLE'
export const USER_LEVEL = 'USERLEVEL'
export const SYSTEM_IMAGE = 'SYSTEM_IMAGE'
export const SYSTEM_NAME = 'SYSTEM_NAME'
export const SYSTEM_TITLE = 'SYSTEM_TITLE'
export const SET_HOME_SOLD = 'SET_HOME_SOLD'
export const SET_HOME_STOCK = 'SET_HOME_STOCK'
export const SET_HOME_MAP = 'SET_HOME_MAP'
export const ORG_NAME = 'ORG_NAME'
export const SET_LANG = 'SET_LANG'
export const SET_NOTICE_TYPE = 'SET_NOTICE_TYPE'
export const SET_ALARM_CONFIG = 'SET_ALARM_CONFIG'